import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { SHOWCASE, waLink } from "@/data/site";

const Card = ({ item }) => (
  <div
    data-testid="showcase-card"
    className="group relative h-44 w-72 shrink-0 overflow-hidden rounded-xl border border-bp-border"
  >
    <img
      src={item.img}
      alt={item.label}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
    <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
      <span className="grid place-items-center w-12 h-12 rounded-full bg-bp-primary/90 text-white">
        <Play className="w-5 h-5 fill-white" />
      </span>
    </div>
    <div className="absolute bottom-3 left-3 right-3">
      <span className="text-[10px] uppercase tracking-[0.18em] text-bp-accent font-semibold">{item.category}</span>
      <div className="text-white font-heading font-medium text-sm">{item.label}</div>
    </div>
  </div>
);

const Row = ({ items, reverse }) => (
  <div className="marquee-mask overflow-hidden">
    <div
      className={`flex gap-4 w-max ${reverse ? "animate-marquee-rev" : "animate-marquee"} hover:[animation-play-state:paused]`}
    >
      {[...items, ...items].map((item, i) => (
        <Card key={`${item.label}-${i}`} item={item} />
      ))}
    </div>
  </div>
);

export const Showcase = () => {
  const half = Math.ceil(SHOWCASE.length / 2);
  return (
    <section id="contenido" data-testid="showcase-section" className="relative py-24 lg:py-32 border-y border-bp-border overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-12"
        >
          <span className="text-sm text-bp-primary uppercase tracking-[0.2em] font-semibold">Contenido</span>
          <h2 className="font-heading text-3xl lg:text-5xl font-semibold tracking-tight mt-4">
            Deportes, películas, series y mucho más
          </h2>
          <p className="mt-4 text-[#A3A3A3]">
            Todo lo que amas ver, en vivo y on demand, actualizado cada día.
          </p>
        </motion.div>
      </div>

      <div className="space-y-4">
        <Row items={SHOWCASE.slice(0, half)} />
        <Row items={SHOWCASE.slice(half)} reverse />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-12 mt-12 text-center">
        <a
          href={waLink("Hola, quiero ver el catálogo completo de BrothersPlus TV.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="showcase-cta"
          className="inline-flex items-center gap-2 rounded-full bg-bp-primary px-7 py-3.5 font-semibold text-white transition-all duration-200 hover:bg-bp-primaryHover active:scale-95 hover:shadow-[0_0_28px_rgba(46,125,255,0.55)]"
        >
          <Play className="w-4 h-4 fill-white" /> Solicitar acceso
        </a>
      </div>
    </section>
  );
};
